export default {
  props: {
    height: {
      type: [String, Number],
      default () {
        return '300px';
      },
    },
    width: {
      type: [String, Number],
      default () {
        return 300;
      },
    },
  },
  computed: {
    localWidth () {
      return typeof this.width === 'number' ? `${this.width}px` : this.width;
    },
    localHeight () {
      return typeof this.height === 'number' ? `${this.height}px` : this.height;
    },
  },
};
